import React, { useContext, useEffect, useCallback } from 'react'
import { CrudeContext } from '@3m5/crude-frontend/dist/crudeHooks'
import { useHistory } from 'react-router-dom'
import s from './crudeContainerStyles.scss'

import ScreenContainerMain from '~shared/components/ScreenContainerMain'
import i18n from 'i18next'
import { useAddToast } from '~utils/useAddToast'

const CrudeContainer: React.FC = () => {
  const { Crude } = useContext(CrudeContext)
  const history = useHistory()
  const toast = useAddToast()

  const crudeEntityChangeFunction = useCallback(({ detail }: CustomEvent) => {
    if (detail && typeof detail === 'string') {
      history.replace(`/crude/${detail}`) // todo detail is a bad name in my optionen, please try to change it
    }
  }, [history])

  const crudeInternalErrorFunction = useCallback(({ detail }: CustomEvent) => {
    // detail.message is translated by crude
    if (detail.severity === 'error' && detail.message.length > 0) {
      toast({
        severity: 'error',
        content: detail.message,
      })
    } else if (detail.eventType === 'delete' && detail.severity === 'error') {
      toast({
        severity: 'error',
        content: i18n.t('error:cantDelete'),
      })
    } else if (detail.eventType === 'update' && detail.severity === 'error') {
      console.log(detail)
      if (detail.message === 'not found') {
        toast({
          severity: 'error',
          content: i18n.t('error:cantUpdateNotFound'),
        })
      } else if (detail.message.toLowerCase().includes('lacking permission')) {
        toast({
          severity: 'error',
          content: i18n.t('error:lackingPermission'),
        })
      } else {
        toast({
          severity: 'error',
          content: i18n.t('error:cantUpdate'),
        })
      }
    } else if (detail.severity === 'error') {
      console.log(detail)
      toast({
        severity: 'error',
        content: i18n.t('error:unknownErrorHasOccurred'),
      })
    }
  }, [])

  useEffect(() => {
    window.addEventListener('CrudeEntityChange', crudeEntityChangeFunction as EventListener)
    window.addEventListener('CrudeMessages', crudeInternalErrorFunction as EventListener)
    return () => {
      window.removeEventListener('CrudeEntityChange', crudeEntityChangeFunction as EventListener)
      window.removeEventListener('CrudeMessages', crudeInternalErrorFunction as EventListener)
    }
    // eslint-disable-next-line -- on mount
  }, [])

  return <ScreenContainerMain
    className={s.crudeContainerScreen}
  >
    <Crude />
  </ScreenContainerMain>
}

export default CrudeContainer
